import { render } from "./ScatterWrapper.vue?vue&type=template&id=fc631a9a&scoped=true"
import script from "./ScatterWrapper.vue?vue&type=script&lang=js"
export * from "./ScatterWrapper.vue?vue&type=script&lang=js"

import "./ScatterWrapper.vue?vue&type=style&index=0&id=fc631a9a&lang=scss&scoped=true"

import exportComponent from "/Users/kakkote/Mediadeski/2022-01-aluevaalit-kompassianalyysi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc631a9a"]])

export default __exports__